function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m139.702 317.377c13.119 11.113 21.818 26.169 24.961 42.604h76.327v-106.899c-25.849-6.678-45-30.195-45-58.102h30c0 16.542 13.458 30 30 30s30-13.458 30-30h30c0 27.906-19.151 51.424-45 58.102v106.898h76.344c3.177-16.431 11.959-31.562 25.202-42.823 40.326-34.29 63.454-84.289 63.454-137.177 0-161.352-196.781-240.593-308.844-125.467-73.136 75.138-66.884 195.57 12.556 262.864z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m255.99 511.98c33.084 0 60-26.916 60-60h-120c0 33.084 26.916 60 60 60z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m165.99 389.98h180v32h-180z"
}));

function Svg118(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "inherit",
    height: 512,
    viewBox: "0 0 511.98 511.98",
    width: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg118);
export default __webpack_public_path__ + "static/media/1_18.99a8950b.svg";
export { ForwardRef as ReactComponent };